import { render, staticRenderFns } from "./ModalPdf.vue?vue&type=template&id=744fd828&"
import script from "./ModalPdf.vue?vue&type=script&lang=js&"
export * from "./ModalPdf.vue?vue&type=script&lang=js&"
import style0 from "./ModalPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports